<template>
  <transition name="fade">
    <div v-if="visible" class="ui-loading-overlay">
      <div class="ui-loading-box">
        <div class="ui-loading-spinner"></div>
        <p class="ui-loading-text">{{ text }}</p>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'BaseLoading',
  props: {
    visible: Boolean,
    text: { type: String, default: '加载中...' }
  }
}
</script>

<style>
.ui-loading-overlay {
  position: fixed;
  inset: 0;
  z-index: 11000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.14);
}

.ui-loading-box {
  /* width: 180px; */
  max-width: 90vw;
  padding: 20px 18px;
  background: rgba(255, 255, 255,1);
  border-radius: 18px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
}

.ui-loading-spinner {
  width: 42px;
  height: 42px;
  border: 4px solid rgba(255, 102, 0, 0.24);
  border-top-color: #ff6600;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.ui-loading-text {
  margin: 0;
  color: #333333;
  font-size: 14px;
  text-align: center;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>